<template>
  <v-card class="rounded-lg">
    <v-col>
      <v-col>
        <basicInformation ref="basicForm" />
      </v-col>
      <v-col>
        <descriptionCombo ref="descriptionForm" />
      </v-col>
      <v-col>
        <imagesCombo ref="imagesForm" />
      </v-col>
      <v-col>
        <productsCombo ref="productsForm" />
      </v-col>
    </v-col>
    <div class="actions-edit">
      <v-spacer></v-spacer>
      <v-btn text class="rounded-lg mr-3" @click="backToCombos">
        {{ $t("events.cancel") }}
      </v-btn>
      <v-btn color="primary" class="rounded-lg" @click="saveCombo">
        {{ $t("events.save") }}
      </v-btn>
    </div>
  </v-card>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "EditComboForm",
  components: {
    imagesCombo: () =>
      import("@/components/produtos/combos/registrationSteps/images.vue"),
    basicInformation: () =>
      import(
        "@/components/produtos/combos/registrationSteps/basicInformation.vue"
      ),
    descriptionCombo: () =>
      import(
        "@/components/produtos/combos/registrationSteps/descriptionCombo.vue"
      ),
    productsCombo: () =>
      import(
        "@/components/produtos/combos/registrationSteps/productsCombo.vue"
      ),
  },
  methods: {
    ...mapActions(["showSnackbarError", "getComboById", "setTypeCombo"]),
    saveCombo() {
      if (!this.$refs.basicForm.handlerContinue()) {
        this.scrollToComponent(this.$refs.basicForm.$el);
        this.showSnackbarError(this.$t("events.combos.basic-info-error"));
        return;
      }
      if (!this.$refs.descriptionForm.handlerContinue()) {
        this.scrollToComponent(this.$refs.descriptionForm.$el);
        this.showSnackbarError(
          this.$t("events.combos.combo-description-error")
        );
        return;
      }
      if (!this.$refs.imagesForm.handlerContinue()) {
        return;
      }
      if (!this.$refs.productsForm.handlerContinue()) {
        return;
      }
    },
    backToCombos() {
      this.$router.push("/combos");
    },
    scrollToComponent(element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
};
</script>
<style scoped>
.actions-edit {
  position: fixed;
  display: flex;
  padding: 1rem 2.5rem;
  bottom: 0;
  right: 0;
  width: 100%;
  background-color: #fff;
  border-top: 1px solid #e0e0e0;
  z-index: 3;
}
</style>
